import {
  SHOW_LOADER,
  HIDE_LOADER,
} from '../actions/userManagement/userManagement.actiontype.js';

const initialState = {
  isLoading: false,
};

const UserManagement = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        isLoading: true,
      };
    case HIDE_LOADER: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};

export default UserManagement;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
